import {
  isValidOperationType,
  PeOrderOperationType,
} from 'enums/modules/pe/peOperationType';
import useQueryParam from 'hooks/shared/useQueryParam';
import CreatePeCompanyOrderForm from 'presentation/containers/modules/pe/forms/CreatePeCompanyOrderForm';
import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import { FC } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

const CreatePeCompanyOrderPage: FC = () => {
  const [companyName] = useQueryParam<string | undefined>('company_name', {
    ifAbsent: undefined,
    provider: (val) => val,
  });

  const [quantity] = useQueryParam<number | undefined>('quantity', {
    ifAbsent: undefined,
    provider: (val) => +val,
  });

  const [operationType] = useQueryParam<PeOrderOperationType | undefined>(
    'operation_type',
    {
      ifAbsent: undefined,
      provider: (val) => (isValidOperationType(+val) ? +val : undefined),
    }
  );

  const [requestedPrice] = useQueryParam<number | undefined>(
    'requested_price',
    {
      ifAbsent: undefined,
      provider: (val) => +val,
    }
  );

  const [currency] = useQueryParam<string | undefined>('company_currency', {
    ifAbsent: undefined,
    provider: (val) => val,
  });

  const { companyId } = useParams();

  const location = useLocation();

  if (!companyId || !companyName) {
    return (
      <Navigate to={AppRoute.peOffers} replace state={{ from: location }} />
    );
  }

  return (
    <ActivesPageLayout>
      <CreatePeCompanyOrderForm
        companyName={companyName}
        companyId={+companyId}
        quantity={quantity}
        operationType={operationType}
        requestedPrice={requestedPrice}
        companyCurrency={currency}
      />
    </ActivesPageLayout>
  );
};

export default CreatePeCompanyOrderPage;
